import React from 'react';
import './PowerSignatureProgress.css';


export function plannedPowerSigners(poder) {
  if (poder.actSignerPlan?.length) return poder.actSignerPlan.map((person, index) => ({ ...person, recipientId: `planned-${index}`, status: 'created' }));
  const lawyer = poder.signaturePreviewLawyer || {};
  const contact = poder.clientIntake || {};
  const physical = poder.generalData?.registeredCompany === 'physical';
  const participants = [{ recipientId: 'planned-1', name: poder.internalResponsibles?.wisbyLawyerName || lawyer.name || '', email: poder.internalResponsibles?.wisbyLawyerEmail || lawyer.email || '', roles: [physical ? 'Abogado Wisby' : 'Escrutador'], routingOrder: 1, status: 'created' }];
  if (physical) participants.push({ recipientId: 'planned-2', name: poder.companyName || '', email: poder.generalData?.grantorEmail || '', roles: ['Otorgante'], routingOrder: 2, status: 'created' });
  else participants.push({ recipientId: 'planned-2', name: contact.secretaryName || '', email: contact.secretaryEmail || '', roles: ['Secretario'], routingOrder: 2, status: 'created' }, { recipientId: 'planned-3', name: contact.presidentName || '', email: contact.presidentEmail || '', roles: ['Presidente'], routingOrder: 3, status: 'created' });

  return participants;
}

export default function PowerSignatureProgress({
  poder, onRefresh, refreshing=false, error='', additionalSigners=[], title='Flujo de firmas', subtitle,
}) {
  const recorded = Boolean(poder.signatureParticipants?.length);
  const digital = recorded ? poder.signatureParticipants : plannedPowerSigners(poder);
  const participants = [
    ...digital.map((person,index) => ({ ...person, section:'Acta Wisby', routingOrder:person.routingOrder || index+1 })),
    ...additionalSigners.map((person,index) => ({ ...person, section:'Escritura Pública · Firma física', routingOrder:digital.length+index+1 })),
  ];
  const completed = participants.filter(person => person.status === 'completed').length;
  const allSigned = participants.length > 0 && completed === participants.length;
  return <section className="power-signature-progress" aria-label={title}>
    <div className="power-signature-heading">
      <div><h3>{title}</h3><p>{subtitle || (recorded ? `${completed} de ${participants.length} firmas aceptadas` :
        poder.generalData?.registeredCompany === 'physical'
          ? 'El abogado Wisby firma primero y después el otorgante.'
          : 'Orden previsto: escrutador, secretario y presidente.')}</p></div>
      {onRefresh && <button type="button" disabled={refreshing || !poder.envelopeId} onClick={onRefresh}>
        {refreshing ? 'Verificando…' : 'Actualizar firmas'}</button>}
    </div>
    {error && <p role="alert">{error}</p>}
    <p className={`power-signature-summary${allSigned ? ' is-complete' : ''}`}>
      {allSigned ? 'Todas las firmas fueron aceptadas' : !recorded ?
        'Firmantes previstos · Las solicitudes aún no se han enviado'
        : `${completed} de ${participants.length} firmas aceptadas`}</p>
    <ol className="power-signature-timeline" aria-label="Firmantes en orden">
      {participants.map((person,index) => {
        const status = person.status || 'created';
        const signed = status === 'completed';
        const label = { created:'Pendiente de firma', delivered:'Pendiente de firma',
          sent:'Enviada', completed:'Aceptada', declined:'Rechazada', voided:'Rechazada',
          autoresponded:'Correo no entregado', authenticationfailed:'No se pudo autenticar' }[status] || status;
        const roles = Array.isArray(person.roles) ? person.roles.join(' / ') : person.roles || 'Firmante';
        const signedAt = person.signedAt && !Number.isNaN(new Date(person.signedAt).getTime()) ? new Date(person.signedAt) : null;
        return <li key={person.recipientId || person.key || index} className={signed ? 'is-complete' : ''}>
          <span className="power-signature-order" aria-hidden="true">{signed ? '✓' : index+1}</span>
          <div className="power-signature-person">
            <span className="power-signature-category">{person.section} · Turno {person.routingOrder}</span>
            <strong className="power-signature-person-title"><span>{roles}:</span> <span>{person.name || 'Nombre pendiente'}</span></strong>
            {person.email ? <span className="power-signature-email">Correo: <a href={`mailto:${person.email}`}>{person.email}</a></span>
              : person.section === 'Acta Wisby' && <span className="power-signature-email">Correo pendiente</span>}
            <span className="power-signature-status-line">Estado: <strong className={`power-signature-state state-${status}`}>{label}</strong></span>
            {signed && signedAt && <time dateTime={signedAt.toISOString()}>Firmada el {signedAt.toLocaleString('es-MX',{timeZone:'America/Monterrey',dateStyle:'medium',timeStyle:'short'})}</time>}
            {person.onAction && !signed && <button type="button" className="power-signature-register"
              onClick={person.onAction}>Registrar firma</button>}
          </div>
        </li>;
      })}
    </ol>
  </section>;
}
